var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"aha-spinner__wrapper"},[_c('span',{staticClass:"aha-spinner",class:`aha-spinner--${_vm.variant} aha-spinner--${_vm.size}`}),(_vm.text)?_c('span',{staticClass:"mt-4"},[_vm._v(" "+_vm._s(_vm.text)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }